<template>
  <el-dialog :width="loginInfo.isCloseIllustration !== true ? '916px' : '528px'" :style="{ '--themeColor': themeColor, '--el-dialog-padding-primary': 0 }"
    v-loading="isLoading" append-to-body :show-close="false" @closed="closed" :close-on-click-modal="false"
    v-model="visible">
    <div class="login-info">
      <div class="close-dia" @click="closeDialog">
        <i class="iconfont icon-guanbi2fill"></i>
      </div>
      <div class="login-info-img" v-if="loginInfo.isCloseIllustration !== true">
        <img v-if="isNew" :src="imgUrl">
        <el-carousel height="100%" trigger="click" v-else :arrow="loginInfo[upType].length > 1 ? 'hover' : 'never'"
          :indicator-position="loginInfo[upType].length > 1 ? '' : 'none'">
          <el-carousel-item v-for="item in loginInfo[upType]" :key="item">
            <img :src="isHttp(item) ? item : $imgurl + item">
          </el-carousel-item>
        </el-carousel>
        <wxlogin class="wx-login-qr" v-show="loginInfo.qrCode === 'illustration'" :appid="appid" scope="snsapi_login"
          href="data:text/css;base64,LndlYl9xcmNvZGVfdHlwZV9pZnJhbWUgLndlYl9xcmNvZGVfYXJlYXtkaXNwbGF5Om5vbmV9LndlYl9xcmNvZGVfdHlwZV9pZnJhbWV7d2lkdGg6MTAwJTtkaXNwbGF5OmZsZXg7YWxpZ24taXRlbXM6Y2VudGVyO2p1c3RpZnktY29udGVudDpjZW50ZXJ9LndlYl9xcmNvZGVfdHlwZV9pZnJhbWUgLm9sZC10ZW1wbGF0ZSAudGl0bGV7ZGlzcGxheTpub25lfS53ZWJfcXJjb2RlX3R5cGVfaWZyYW1lIC5vbGQtdGVtcGxhdGUgLnBhbmVsQ29udGVudCAud3JwX2NvZGV7bWFyZ2luLXRvcDowO3dpZHRoOjIwMHB4O2hlaWdodDoyMDBweH0ud2ViX3FyY29kZV90eXBlX2lmcmFtZSAub2xkLXRlbXBsYXRlIC5wYW5lbENvbnRlbnQgLndycF9jb2RlIGltZ3ttYXJnaW4tdG9wOjA7d2lkdGg6MTAwJTtoZWlnaHQ6MTAwJTtib3gtc2l6aW5nOmJvcmRlci1ib3g7Ym9yZGVyOm5vbmV9LndlYl9xcmNvZGVfdHlwZV9pZnJhbWUgLm9sZC10ZW1wbGF0ZSAucGFuZWxDb250ZW50IC5pbmZve2Rpc3BsYXk6bm9uZX0K"
          :redirect_uri="redirect_uri" />
      </div>
      <div class="login-info-con">
        <ul class="l-login" v-if="type(1) && !type(3, 'registerType')">
          <li class="l-login-text login-title" :style="{
            marginBottom: step(1) ? '' : '40px'
          }">{{ loginTitle }}</li>
          <template v-if="openMenthods === 'all'">
            <li class="l-login-tips login-tips" v-show="step(1) && !type(2, 'registerType')">{{ isLogin ?
              `${loginInfo.title || ''}` :
              '' }} <label v-if="isRegister">没有账号?</label> <span @click="goFreeRegister" v-if="isRegister">免费注册</span>
            </li>
            <li class="l-login-tips login-tips"
              v-show="type(2, 'registerType') && !(type(2, 'registerType') && step(2, 'registerStep'))">
              已有账号？<span @click="setType(1, 'registerType')">直接登录</span></li>
          </template>
          <template v-if="type(1, 'registerType')">
            <li class="l-login-tab" v-show="step(1) && type(1, 'registerType')">
              <div @click="activeTab = item.value" :class="activeTab === item.value ? 'active-tab' : ''"
                class="logon-tab" v-for="item in tabOptionList" :key="item.value">
                {{ item.label }}
              </div>
            </li>
            <li class="l-login-inp" v-if="!step(4)">
              <el-input class="login-inp" autocomplete="new-password" :placeholder="activePlaceholder"
                v-model="account" />
            </li>
            <li class="l-login-inp" style="margin-bottom: 16px;" v-if="step(1) || step(4)">
              <el-input @keydown.enter="goLogin" class="login-inp" autocomplete="new-password" show-password
                :placeholder="step(1) ? '请输入密码' : '请输入8-20位密码，超出无效'" v-model="password" />
            </li>
            <li class="l-login-inp" v-if="step(4)">
              <el-input class="login-inp" autocomplete="new-password" show-password placeholder="请再次输入8-20位密码，超出无效"
                v-model="cpassword" />
            </li>
            <li class="l-login-validate login-tips" :class="validateInfo.isSuccess ? 'validate-scuuess' : ''"
              @click="goValidate" v-if="step(2) || (step(3) || (step(1) && captchatoken))">
              <svg v-if="validateInfo.isSuccess" t="1652076018727" class="icon" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="1898" width="19" height="19">
                <path
                  d="M512 0C228.430769 0 0 228.430769 0 512s228.430769 512 512 512 512-228.430769 512-512S795.569231 0 512 0z m0 945.230769C271.753846 945.230769 78.769231 752.246154 78.769231 512S271.753846 78.769231 512 78.769231s433.230769 192.984615 433.230769 433.230769-192.984615 433.230769-433.230769 433.230769z"
                  p-id="1899" fill="#43BF97"></path>
                <path
                  d="M716.8 330.830769l-208.738462 248.123077c-15.753846 15.753846-43.323077 19.692308-59.076923 7.876923L299.323077 472.615385c-15.753846-11.815385-43.323077-7.876923-55.138462 7.876923-11.815385 15.753846-7.876923 43.323077 7.876923 55.138461l149.661539 114.215385c19.692308 15.753846 47.261538 23.630769 74.830769 23.630769 35.446154 0 70.892308-15.753846 94.523077-43.323077l208.738462-248.123077c15.753846-15.753846 11.815385-43.323077-3.938462-55.138461-19.692308-15.753846-43.323077-15.753846-59.076923 3.938461z"
                  p-id="1900" fill="#43BF97"></path>
              </svg>{{ validateInfo.isSuccess ? '验证成功' : '点击完成验证' }}
            </li>
            <li class="l-login-inp l-login-phone" v-if="step(2) || step(3)">
              <el-input class="login-inp" autocomplete="new-password" @keydown.enter="goLogin" placeholder="请输入短信验证码"
                v-model="verificationCode" />
              <div class="inp-validate" @click="sendValidateCode"
                :style="isGetValidateCode ? 'background-color: #F7F8FA;color: #999999;cursor: no-drop;' : ''">
                <span v-if="!isGetValidateCode">获取验证码</span>
                <span v-else>{{ validateCount }}秒后重新获取</span>
              </div>
            </li>
            <li class="l-login-tool" v-if="step(1) || step(2)">
              <div class="dynamic" @click="setStep(step(1) ? 2 : 1)">{{ step(1) ? '手机动态码登录' : '账号登录' }}
              </div>
              <div class="find" @click="findPass">找回密码</div>
            </li>
            <li class="l-login-btn">
              <button class="btn cancle login-btn" v-if="step(3)" style="margin-right: 24px;"
                @click="setStep(2)">取消</button>
              <button class="btn login-btn" @click="goLogin">{{ loginBtnText }}</button>
            </li>
            <li class="tip-words" v-if="step(4)">
              <p>注：{{ tipWords[pwdLevel] }}</p>
              <p v-if="jmShow">新密码生效后，上网认证密码会同步更新！</p>
            </li>
            <li v-if="step(1) || step(2)" class="login-tipsss"
              style="margin-top: 20px;text-align: center;padding-right:67px;"
              :style="isPd ? 'padding-bottom:40px' : ''">
              {{ type(1, 'loginType') ? '登录' : '注册' }}代表同意 <span @click="protocolVisible = true">《隐私政策》</span>
            </li>
            <li v-if="step(1) || step(2)"
              style="color:#F02727;text-align:center;padding-bottom:10px;padding-right:67px;">
              本平台为互联网非涉密平台，严禁处理、传输国家秘密</li>
            <li v-if="(step(1) || step(2)) && isXiamenUniversity">
              <el-divider>其他方式登录</el-divider>
              <div class="xmulogin">
                <el-image @click="goXMU" class="xmu"
                  :src="'https://bigdata.topeti.com/PCRepository/mainPlatform/btn-xiada.png'"></el-image>
              </div>
            </li>
          </template>
          <template v-else>
            <template v-if="step(1, 'registerStep')">
              <li class="l-login-inp" v-for="(item, idx) in fOptions" v-show="item.isAppen" :key="idx">
                <el-tooltip class="item" effect="dark" :disabled="!tips(item)" :content="tips(item)" placement="top">
                  <el-input @keydown.enter="goToRegister" :maxlength="20" :show-word-limit="numLimit[item.title]"
                    :show-password="['password', 'password0'].indexOf(item.title) !== -1" class="login-inp"
                    :autocomplete="item.title === 'password' ? 'new-password' : ''" :placeholder="registerPl(item)"
                    v-model="registerInfo[item.title]" />
                </el-tooltip>
              </li>
              <template v-if="isNeedPhoneValidate">
                <li class="l-login-inp l-login-imgcode">
                  <el-input class="login-inp inp-imgcode" placeholder="请输入图形验证码" v-model="imgCode">
                    <template #suffix>
                      <div class="inp-img" @click="getCaptcha('captchatokenRegister')">
                        <img :src="$apiurl + '/openapi/captcha?captchatoken=' + captchatokenRegister" alt="">
                      </div>
                    </template>
                  </el-input>
                </li>
                <li class="l-login-inp l-login-phone">
                  <el-input class="login-inp" @keydown.enter="goToRegister" placeholder="请输入短信验证码"
                    v-model="verificationCode" />
                  <div class="inp-validate" @click="sendRegisterCode"
                    :style="isGetValidateCode ? 'background-color: #F7F8FA;color: #999999;cursor: no-drop;' : ''">
                    <span v-if="!isGetValidateCode">获取验证码</span>
                    <span v-else>{{ validateCount }}秒后重新获取</span>
                  </div>
                </li>
              </template>
            </template>
            <template v-else-if="step(2, 'registerStep')">
              <li class="l-login-inp" v-for="(item, idx) in sOptions" :key="idx" v-show="item.isAppen">
                <el-input @keydown.enter="goToRegister" v-if="['idcard'].indexOf(item.title) !== -1"
                  :show-word-limit="numLimit[item.title]" class="login-inp"
                  :autocomplete="item.title === 'password' ? 'new-password' : ''" :placeholder="registerPl(item)"
                  v-model="registerInfo[item.title]" />
                <el-select :disabled="item.readonly" class="register-sel"
                  v-else-if="['type', 'idcardtype', 'sex'].indexOf(item.title) !== -1" :placeholder="registerPl(item)"
                  v-model="registerInfo[item.title]">
                  <el-option v-for="citem in item.sels" :key="citem.id" :label="citem.name" :value="citem.id" />
                </el-select>
                <el-date-picker value-format="YYYY-MM-DD" class="register-sel"
                  v-else-if="['birthday'].indexOf(item.title) !== '-1'" v-model="registerInfo[item.title]" type="date"
                  :placeholder="registerPl(item)" />
              </li>
            </template>
            <li class="l-login-btn">
              <button class="btn login-btn" @click="goToRegister">{{ isNext && step(1, 'registerStep') ?
                '下一步' : '注册' }}</button>
            </li>
            <li v-if="step(1) || step(2)" class="login-tipsss"
              style="margin-top: 20px;text-align: center;padding-right:67px;"
              :style="isPd ? 'padding-bottom:40px' : ''">
              {{ type(1, 'loginType') ? '登录' : '注册' }}代表同意 <span @click="protocolVisible = true">《隐私政策》</span>
            </li>
            <li v-if="step(1) || step(2)" style="color:#F02727;padding-bottom:10px;padding-right:67px;">
              本平台为互联网非涉密平台，严禁处理、传输国家秘密
            </li>
          </template>
        </ul>
        <ul class="qr-login" v-show="type(2) || type(3, 'registerType')">
          <li class="login-title" style="margin-bottom: 16px;">{{ qrTitle }}</li>
          <li class="qr-login-img">
            <!-- 原h5注册功能，欧总说先保留 -->
            <!-- <vue-qr :size="255" :text="webUrl" v-show="type(3, 'registerType')"></vue-qr> -->
            <wxlogin style="height: 100%;" v-if="type(2) && !openGzhLogin" :appid="appid" scope="snsapi_login"
              href="data:text/css;base64,LndlYl9xcmNvZGVfdHlwZV9pZnJhbWUgLndlYl9xcmNvZGVfYXJlYSB7DQogIGRpc3BsYXk6IG5vbmU7DQp9DQoNCi53ZWJfcXJjb2RlX3R5cGVfaWZyYW1lIC5vbGQtdGVtcGxhdGUgLnRpdGxlIHsNCiAgZGlzcGxheTogbm9uZTsNCn0NCg0KLndlYl9xcmNvZGVfdHlwZV9pZnJhbWUgLm9sZC10ZW1wbGF0ZSAucGFuZWxDb250ZW50IC53cnBfY29kZSB7DQogIG1hcmdpbi10b3A6IDA7DQogIHdpZHRoOiAyNTVweDsNCiAgaGVpZ2h0OiAyNTVweDsNCn0NCg0KLndlYl9xcmNvZGVfdHlwZV9pZnJhbWUgLm9sZC10ZW1wbGF0ZSAucGFuZWxDb250ZW50IC53cnBfY29kZSBpbWcgew0KICBtYXJnaW4tdG9wOiAwOw0KICB3aWR0aDogMTAwJTsNCiAgaGVpZ2h0OiAxMDAlOw0KICBib3gtc2l6aW5nOiBib3JkZXItYm94Ow0KICBib3JkZXI6IG5vbmU7DQp9DQoNCi53ZWJfcXJjb2RlX3R5cGVfaWZyYW1lIC5vbGQtdGVtcGxhdGUgLnBhbmVsQ29udGVudCAuaW5mbyB7DQogIGRpc3BsYXk6IG5vbmU7DQp9DQo="
              :redirect_uri="redirect_uri"></wxlogin>
            <regWx v-else :skey="skey" ref="regWxRef" @wxloginSuccess="wxloginSuccess" />
          </li>
          <li v-if="step(1) || step(2)" class="login-tipsss">
            {{ type(2, 'loginType') ? '登录' : '注册' }}代表同意 <span @click="protocolVisible = true">《隐私政策》</span>
          </li>
          <li v-if="step(1) || step(2)" style="color:#F02727;padding-bottom:10px;">本平台为互联网非涉密平台，严禁处理、传输国家秘密
          </li>
        </ul>
      </div>
      <div class="to-other" v-if="(step(1) && !type(3)) || step(2)">
        <!-- <div class="to-other" v-if="(type(2,'registerType') || type(3,'registerType')) && isWXRegister"></div> -->
        <i class="iconfont" v-if="showIcon"
          :class="(type(1) && !type(3, 'registerType')) || type(2, 'registerType') ? 'icon-erweima-' : 'icon-diannao'"
          @click="changeLogin(type(1, 'registerType') ? 'loginType' : 'registerType')"></i>
        <div class="to-other-tips" v-if="type(1, 'registerType') && isAppenQrCode">{{ type(1) ? '微信扫码登录' : '账号登录'
        }}</div>
        <div class="to-other-tips" v-if="!type(1, 'registerType') && isAccountRegister && isWXRegister">{{
          type(2, 'registerType') ? '扫码安全注册' : '其他注册方式' }}</div>
      </div>
      <div class="back-prev" v-if="step(3) || step(4) || loginType === 3">
        <i class="iconfont icon-jiantou" @click="back"></i>
      </div>
    </div>
    <el-dialog width="305px" :show-close="false" :close-on-click-modal="false" v-model="validateInfo.isAppen"
      append-to-body v-if="validateInfo.isAppen">
      <template #header>
        <div class="validate-title">
          <span>请完成验证</span>
          <i class="iconfont icon-shanchu3" @click="validateInfo.isAppen = false"></i>
        </div>
      </template>
      <div class="validate-box">
        <slide-verify slider-text="拖动做左边滑块完成上方拼图" @success="validateSucess" @fail="onFail"></slide-verify>
      </div>
    </el-dialog>
    <el-dialog :before-close="closeReg" :style="{ '--themeColor': themeColor }" width="480px"
      :close-on-click-modal="false" append-to-body v-model="visibleReg" class="sign-up-success" :show-close="false">
      <div class="sign-up">
        <img class="sign-up-img" src="https://bigdata.topeti.com/PCRepository/middleground/success.png" alt="">
        <h1 class="sign-up-title">恭喜您注册成功</h1>
        <button class="sign-up-btn login-btn" @click="goIndex">进入系统</button>
      </div>
    </el-dialog>
    <protocol v-model:isView="protocolVisible" />
    <upIphone @close="getUserDesks(); closeDialog()" :isWebSite="true" ref="upIphone" />
    <ChangeUser v-model:isView="isViewChangeUser" type="add" :list="userList" />
  </el-dialog>
</template>

<script>
import wxlogin from '@/pages/components/vue-wxlogin';
import upIphone from '@/components/common/upIphone.vue'
import { iphone } from "@/util/util";
import { login, getaccesstoken, getloginsmsvalidcode, getsecurityrules, getphonemultipleaccounts, sendloginmpmessage, updateregisteruser, smsvalidcodemultipleaccountslogin } from "@/port/pages/login";
import { openapiResetpassword, openapiValidsliderpasswordcode, mobileGetpasswordsmsvalidcode, getregvalidcode, validsmsregcode, registeruser, getuserschoollist, getoutpwdconfig, getoutregistercode } from '@/port/common/upIphone'
import { encryptPassword } from '@/util/encrypt.js'
import { sha1 } from '@/util/sha1.js'
import webSocketClass from "@/api/ws"
import { cloneDeep } from 'lodash'
import ChangeUser from './changeUser.vue';
import { emitter } from '@/util/util'
import { getuserdesks } from '@/port/schoolInstrument/appConfig'
import { defineAsyncComponent } from 'vue';
export default {
  // 组件名称
  name: 'loginInfo',
  // 组件参数 接收来自父组件的数据
  props: {
    isView: {
      type: Boolean,
      default: false
    },
    registerconfig: {
      type: Object,
      default: () => ({})
    },
    themeColor: {
      type: String,
      default: '#4e86ff'
    },
    loginStatus: {
      type: String,
      default: 'keep'
    },
    loginMethod: {
      type: Number,
      default: 4
    }
  },
  // 局部注册的组件
  components: {
    wxlogin,
    ChangeUser,
    upIphone,
    regWx: defineAsyncComponent(() => import('@/pages/components/regWx')),
    protocol: defineAsyncComponent(() => import('./protocol.vue')),
  },
  // 组件状态值
  data() {
    return {
      visible: false,
      tabOption: [{
        value: 1,
        label: '账号',
        placeholder: '请输入账号'
      }, {
        value: 2,
        label: '身份证号',
        placeholder: '请输入身份证号'
      }, {
        value: 3,
        label: '手机号',
        placeholder: '请输入手机号'
      }],
      activeTab: 1,
      password: '', // 密码
      cpassword: '', // 密码
      account: '', // 账号 / 电话号码 / 身份证号码
      verificationCode: '', // 验证码
      imgCode: '',
      loginType: 1, // 登录状态  1:正常登录 2:扫码绑定登录  
      loginStep: 1, // 登录步骤  1: 账号 2:动态码 3:找回密码 4:重置密码
      registerType: 1, // 注册状态  1 没有任何变化 2 通过账号注册 3 通过扫二维码注册
      registerStep: 1, // 注册步骤  1 没有任何变化 2 完善信息
      skey: this.$route.params.skey || this.$route.query.skey,
      appid: 'wxddd50d200e27d8d1',
      redirect_uri: 'https://user.topeti.com/wxlogin?type=0-' + document.domain,
      validateInfo: {
        isAppen: false,
        isSuccess: false,
        imagecaptchatoken: '',
        moveLength: ''
      },
      isGetValidateCode: false,
      validateCount: 60,
      captchatoken: '',
      isLoading: false,
      setp3UserName: [],
      loginInfo: {}, // 登录的配置信息
      openLogin: 0, // 是否打开了登录
      openGzhLogin: 0, // 是否打开了公众号登录
      openregister: 0, // 是否打开了注册
      webSocketToken: '', // websocket所需要的token
      registerInfo: {}, // 用户注册所填的信息
      isAccountRegister: true, // 判断是否打开了账号注册
      isWXRegister: true, // 判断是否打开了微信注册
      isNeedPhoneValidate: false, // 判断是否需要手机号验证
      captchatokenRegister: '',
      visibleReg: false,
      webSocketInfo: {},
      captchaNum: 2, // 密码输错多少次后需要滑块验证，默认2次
      pwdconfig: {}, // 密码安全设置相关配置
      schoolId: null,
      pwdLevel: 2,
      pwdKey: '', // 密码安全设置密码
      tipWords: [
        '密码最少8位，英文（含大小写）/数字/特殊字符（@、#、$、%、^、& 、*、~、!）三种组合',
        '密码最少8位，英文/数字/特殊字符（@、#、$、%、^、& 、*、~、!）三种组合',
        '密码最少8位，英文/数字 两种组合',
        '密码最少8位，不限制'
      ],
      isViewChangeUser: false,
      userList: [],
      wxopenId: '', // 微信公众号返回的openId
      wxChooseInfo: false, // 微信注册是否存在选填字段
      wxuserId: null, // 微信注册是成功返回的userid
      wxLoginStatus: 'keep', //微信注册登录是临时登录(visitor)还正常登录(keep)
      protocolVisible: false,
      openMenthods: 'all',
      jmShow: false, //集美教育局差异化显示
      domainHref: '',
    }
  },
  // 侦听器
  watch: {
    loginMethod: {
      handler(val) {
        const type = {
          0: 'login',
          1: 'login',
          2: 'register',
          3: 'register',
        }
        this.openMenthods = type[val] || 'all'
      }
    },
    tabOptionList: {
      handler(val) {
        if (this.loginInfo.loginMethods !== undefined && Array.isArray(val)) {
          this.activeTab = val[0].value
        }
      },
      deep: true,
      immediate: true
    },
    isView: {
      immediate: true,
      handler(val) {
        if (val) {
          const { loginInfo, openregister, openLogin, openGzhLogin, method = {}, setOptions = [] } = this.registerconfig
          this.loginInfo = loginInfo || {}
          this.isAccountRegister = method.account
          this.isWXRegister = method.wx
          this.openregister = Number(openregister)
          this.openLogin = Number(openLogin)
          this.openGzhLogin = Number(openGzhLogin)
          this.wxLoginStatus = this.loginStatus
          const phone = setOptions.find(item => item.title === 'phone')
          const type = setOptions.find(item => item.title === 'type')
          if (phone && phone.required) {
            this.isNeedPhoneValidate = phone.smsVeri
          }
          if (type && type.values && type.readonly && type.values.id !== undefined) {
            this.registerInfo.type = type.values.id
          }
          this.getoutpwdconfig()
          const openMenthodsType = {
            0: 'register',
            1: 'register',
            2: 'login',
            3: 'login',
          }
          this.openMenthods = openMenthodsType[this.loginMethod] || 'all'
          // 登录未开启
          if (!this.openLogin) {
            if (this.isAccountRegister) {
              this.setType(2, 'registerType')
              this.getCaptcha('captchatokenRegister')
            }
            else {
              this.setType(3, 'registerType')
              this.$nextTick(() => {
                if (this.$refs.regWxRef) {
                  this.$refs.regWxRef.onInit()
                }
              });
            }
          }
          else {
            // 开启默认扫码登录，直接显示二维码弹窗
            if (this.loginInfo.scanLogin) {
              this.setType(2, 'loginType')
              this.$nextTick(() => {
                if (this.$refs.regWxRef) {
                  this.$refs.regWxRef.onInit()
                }
              });
            }
          }
          if (this.openMenthods === 'register') {
            // 注册的话 直接 打开注册页
            this.loginType = 1
            this.loginStep = 1
            this.goFreeRegister()
          }
          // 没有打开登录不让他打开弹窗
          // if (!this.isLogin) {
          //     this.$emit('update:isView', false)
          //     return
          // }
          this.visible = true
        }
      }
    },
    visible: {
      immediate: true,
      handler(val) {
        if (!val) {
          this.$emit('update:loginStatus', 'keep')
          this.$emit('update:isView', false)
        }
      }
    }
  },
  mounted() {
    // 集美的单独处理
    if (this.$url === 'https://guanli.xmjmedu.com') {
      this.jmShow = true
      this.appid = 'wx61f1f237e095e1f1'
      this.redirect_uri = 'https://guanli.xmjmedu.com/wxlogin?type=0-' + document.domain
    } else if (this.$url === 'https://zhxy.xmxdzx.com') {
      // 新店中学
      this.appid = 'wxa9a77fa123f992c8'
      this.redirect_uri = `${this.$url}/wxlogin?type=0-${document.domain}`
    } else if (this.$url === 'https://zhihui.xmycxx.com') {
      this.jmShow = true
    }
    if (this.isXiamenUniversity) {
        this.domainHref = window.location.protocol+"//"+window.location.host
    }
    // 获取登录验证码弹出条件
    this.getsecurityrules();
  },
  // 组件方法
  methods: {
    goXMU(){
        window.location.href = "http://ids.xmu.edu.cn/authserver/login?service=" + this.domainHref + "/ixiadalogin";
    },
    isHttp(item) {
      if (typeof item !== 'string') return false
      return item.includes('http')
    },
    closed() {
      this.$emit('close')
      this.loginType = 1
      this.loginStep = 1
      this.registerType = 1
      this.registerStep = 1
    },
    changeLogin(type = 'loginType') {
      let obj = {}
      if (type === 'loginType') {
        obj = {
          1: 2,
          2: 1
        }
        // 扫码登录
        if (this.type(1, 'loginType') && this.openGzhLogin) {
          if (this.$refs.regWxRef) {
            this.$refs.regWxRef.onInit()
          }
        }
        // 账号登录
        else if (!this.type(1, 'loginType') && this.openGzhLogin) {
          this.wxopenId = ''
          if (this.$refs.regWxRef) {
            this.$refs.regWxRef.clearPoll()
          }
        }
      } else {
        obj = {
          2: 3,
          3: 2
        }
        // 扫码注册
        if (this.type(2, 'registerType')) {
          if (this.$refs.regWxRef) {
            this.$refs.regWxRef.onInit()
          }
        }
        // 其他注册
        else {
          this.wxopenId = ''
          if (this.$refs.regWxRef) {
            this.$refs.regWxRef.clearPoll()
          }
        }
        // this.goRegister()
      }
      const item = this[type]
      this[type] = obj[item]
    },
    validateFn(opt) {
      const { msg, type } = opt
      if (!(this[type])) {
        this.$message.error(msg)
        return true
      } else {
        return false
      }
    },
    validateRegFn(opt) {
      const { reg, msg, value } = opt
      if ((reg && !reg.test(value)) || value === '' || value === undefined) {
        this.$message.error(msg)
        return true
      }
    },
    async goToRegister() {
      const obj = {
        username: {
          reg: /^[a-zA-Z0-9]{8,20}$/,
          msg: '请输入正确的用户名'
        },
        password0: {
          reg: /^[^\s\u4e00-\u9fa5]{8,20}$/,
          msg: '请输入正确的密码格式'
        },
        realname: {
          msg: '请设置姓名'
        },
        phone: {
          reg: /^1[3456789]\d{9}$/,
          msg: '请输入正确的手机号码格式'
        },
        type: {
          msg: '请选择您的身份'
        },
        sex: {
          msg: '请选择您的性别'
        },
        idcardtype: {
          msg: '请选择您的证件类型',
        },
        idcard: {
          msg: '请输入正确的证件号码',
          reg: /^\d{17}(\d|X|x)$/
        },
      }
      if (JSON.stringify(this.pwdconfig) !== '{}') {
        // 密码强度验证
        switch (this.pwdconfig.pwdlevel.level) {
          case 1:
            obj.password0.reg = /^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[~!@#$%^&*])[\\da-zA-Z~!@#$%^&*]{8,20}$/
            obj.password0.msg = '密码必须包含英文（含大小写）+ 数字 + 特殊字符'
            break;
          case 2:
            obj.password0.reg = /^(?=.*\\d)(?=.*[a-zA-Z])(?=.*[~!@#$%^&*])[\\da-zA-Z~!@#$%^&*]{8,20}$/
            obj.password0.msg = '密码必须包含英文+ 数字 + 特殊字符'
            break;
          case 3:
            obj.password0.reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/
            obj.password0.msg = '密码必须包含英文+ 数字'
            break;
          default:
            break;
        }
      }
      try {
        if (this.step(1, 'registerStep')) {
          const cpwd = this.fOptions.find(item => item.title === 'password')
          this.fOptions.forEach(item => {
            if (item.isAppen && item.required && !item.isDefault) {
              // 判断是否填写正确格式
              const title = item.title
              const res = this.validateRegFn({ ...obj[title], value: this.registerInfo[title] })
              if (res) throw Error('格式错误')
            }
          })
          if (cpwd && cpwd.isAppen && cpwd.required && !cpwd.default) {
            if (this.registerInfo.password !== this.registerInfo.password0) {
              this.$message.error('两次输入的密码不一致')
              return
            }
          }
          // 判断是去注册还是说去下一步
          if (this.isNeedPhoneValidate) {
            if (this.validateFn({ msg: '请输入正确的图形验证码', type: 'imgCode' })) return
            if (this.validateFn({ msg: '请输入正确的短信验证码', type: 'verificationCode' })) return
            // 如果说需要验证码的话 走接口
            const obj = {
              phone: this.registerInfo.phone,
              captchatoken: this.captchatokenRegister,
              captcha: this.imgCode,
              validcode: this.verificationCode
            }
            const { code, msg } = await validsmsregcode(obj)
            if (code !== 0) {
              this.$message.error(msg)
              return
            }
          }
          if (this.isNext) {
            // 下一步
            this.setStep(2, 'registerStep')
            return
          } else {
            // 否则走注册接口
            this.resRegister()
          }
        } else {
          // 完善信息逻辑
          this.sOptions.forEach(item => {
            if (item.isAppen && item.required) {
              const title = item.title
              const value = this.registerInfo[title]
              const opt = { ...obj[title], value }
              if (title === 'idcard' && value !== 1) {
                opt.reg = /^\d+$/
              }
              const res = this.validateRegFn(opt)
              if (res) throw Error('格式错误')
            }
          })
          // 走注册接口
          this.resRegister()
        }
      } catch (error) {
        console.log(error);
      }
    },
    async resRegister() {
      const defaultObj = {
        realname: `用户${(Math.random() * 10).toString().slice(-6)}`,
        username: `YHM${(Math.random() * 10).toString().slice(-6)}`,
        password0: 'aa123456'
      }
      const info = {
        ...this.registerInfo,
        skey: this.skey,
      }
      if (JSON.stringify(this.pwdconfig) !== '{}') {
        defaultObj.password0 = this.pwdKey
      }
      this.fOptions.forEach(item => {
        if (item.isDefault && !item.required) {
          // 如果说有勾选默认的话                    
          const val = defaultObj[item.title]
          info[item.title] = val
          this.registerInfo[item.title] = val
        }
      })
      // 没有下一步 先走着
      info.password = sha1(info.password0)
      // 微信扫码注册需要传wxopenId
      console.log("wxopenId==", this.wxopenId);
      if (this.wxopenId) {
        info.wxopenId = this.wxopenId
      }
      delete info.password0
      this.isLoading = true
      if (this.wxuserId && this.wxChooseInfo) {
        info.userId = this.wxuserId
        this.wxChooseInfo = false
        const resUpdate = await updateregisteruser(info).catch(() => {
          this.isLoading = false
          this.$message.error('配置问题')
        })
        if (resUpdate.code === 0) {
          this.isLoading = false
          this.visible = false
        } else {
          this.$message.error(res.msg)
          this.isLoading = false
        }
        return false;
      }
      const res = await registeruser(info).catch(() => {
        this.isLoading = false
        this.$message.error('配置问题')
      })

      if (res.code === 0) {
        // 注册成功  打开注册成功页面
        this.isLoading = false
        this.visible = false
        // 微信扫码注册不需要弹出注册成功按钮，直接执行登录操作
        if (this.wxopenId) {
          console.log("微信扫码注册不需要弹出注册成功按钮，直接执行登录操作");
          this.goIndex()
          this.wxuserId = res.data;
          // 如果有选填字段
          if (this.wxChooseInfo) {
            this.visible = true
            this.isLoading = true
            this.setType(2, 'registerType')
          }
        }
        else {
          this.visibleReg = true
        }
      } else {
        this.$message.error(res.msg)
        this.isLoading = false
      }
    },
    closeReg() {

    },
    async goIndex() {
      let Num = ''
      for (let i = 0; i < 6; i++) {
        Num += Math.floor(Math.random() * 10);
      }
      let date = {
        accesstoken: Num,
        accounttype: 1,
        smtype: 1 //密码国密加密
      }

      if (Object.keys(this.webSocketInfo).length !== 0) {
        const { username, password } = this.webSocketInfo
        date.username = username
        // 使用新的加密方法替换原有的 sha1
        date.password = encryptPassword(password)
        // date.password = sha1(password)
      } else {
        const { username, password0: pas, } = cloneDeep(this.registerInfo)
        date.username = username
        date.password = sha1(pas)
      }
      const loginRef = await login(date)
      if (loginRef.code === 0) {
        this.$store.state.postUrl = [];
        loginRef.data.schoolMsg = loginRef.data.listschool[0];
        if (this.wxLoginStatus === 'keep') {
          localStorage.setItem("userMsg", JSON.stringify(loginRef.data));
        }
        this.loginToken(loginRef.data.listschool[0].schoolId, loginRef.data.userId, Num);
      }
    },
    tips(item) {
      const obj = {
        username: '用作登录名，英文+数字，8-12位',
        password0: '英文+数字，8-12位，不允许有空格和中文'
      }
      if (JSON.stringify(this.pwdconfig) !== '{}') {
        // 密码强度验证
        switch (this.pwdconfig.pwdlevel.level) {
          case 1:
            obj.password0 = '英文（含大小写）+ 数字 + 特殊字符'
            break;
          case 2:
            obj.password0 = '英文+ 数字 + 特殊字符'
            break;
          case 3:
            obj.password0 = '英文+数字，8-12位，不允许有空格和中文'
            break;
          default:
            break;
        }
      }
      return obj[item.title] || ''
    },
    registerPl(item) {
      const obj = {
        username: '请设置用户名',
        password0: '请设置登录密码',
        password: '请设置确认登录密码',
        realname: '请设置姓名',
        phone: '请输入手机号可用于登录',
        type: '请选择您的身份',
        sex: '请选择您的性别',
        idcardtype: '请选择您的证件类型',
        birthday: '请选择您的生日',
        idcard: '请输入您的证件号码',
      }
      for (const key in obj) {
        if (item.required) {
          obj[key] += '(必填)'
        }
      }
      return obj[item.title]
    },
    step(value = 1, type = 'loginStep') {
      return this[type] === value
    },
    type(value = 1, type = 'loginType') {
      return this[type] === value
    },
    setStep(value, type = 'loginStep') {
      this[type] = value
      this.validateInfo.isSuccess = false
    },
    setType(value, type = 'loginType') {
      this[type] = value
    },
    goValidate() {
      if (this.validateInfo.isSuccess) return
      // 手机动态码、忘记密码才需要验证是否输入手机号
      if (!iphone(this.account) && (this.step(2) || this.step(3))) {
        this.$message.error('请输入正确的电话号码')
        return
      }
      this.validateInfo.isAppen = true
    },
    validateSucess(e) {
      const { imagecaptchatoken, moveLength } = e
      const obj = {
        imagecaptchatoken,
        moveLength,
        isAppen: false,
        isSuccess: true
      }
      this.validateInfo = obj
    },
    onFail() {

    },
    async sendValidateCode() {
      if (this.isGetValidateCode) return

      // TODO 发送请求
      if (!iphone(this.account)) {
        this.$message.error('请输入正确的电话号码')
        return
      }
      if (!this.validateInfo.isSuccess && this.step(2)) {
        this.$message.error('请完成图形验证')
        return
      }
      const { imagecaptchatoken, moveLength } = this.validateInfo
      let obj = {
        phone: this.account,
      };
      if (this.step(2) || this.step(3)) {
        obj.imagecaptchatoken = imagecaptchatoken
        obj.moveLength = moveLength
      }
      const fn = !this.step(3) ? getloginsmsvalidcode : mobileGetpasswordsmsvalidcode
      const res = await fn(obj)
      if (res.code === 0) {
        this.starCountDown()
      } else {
        this.$message.error(res.msg)
        this.isGetValidateCode = false
      }
    },
    async sendRegisterCode() {
      if (this.isGetValidateCode) return
      if (!iphone(this.registerInfo.phone)) {
        this.$message.error('请输入正确的电话号码')
        return
      }
      if (!this.imgCode) {
        this.$message.error('请输入正确的图片验证码')
        return
      }
      const obj = {
        phone: this.registerInfo.phone,
        captchatoken: this.captchatokenRegister,
        captcha: this.imgCode
      }
      const res = await getregvalidcode(obj).catch(() => {
      })
      if (res.code === 0) {
        this.starCountDown()
      } else {
        this.$message.error(res.msg)
        this.isGetValidateCode = false
      }
    },
    goFreeRegister() {
      if (this.isAccountRegister || !this.openGzhLogin) {
        this.setType(2, 'registerType')
        this.getCaptcha('captchatokenRegister')
      }
      else {
        this.setType(3, 'registerType')
        if (this.$refs.regWxRef) {
          this.$refs.regWxRef.onInit()
        }
      }
    },
    starCountDown() {
      // 倒计时处理
      this.isGetValidateCode = true
      const timer = setInterval(() => {
        this.validateCount -= 1
        if (this.validateCount === 0) {
          this.isGetValidateCode = false
          this.validateCount = 60
          clearInterval(timer)
        }
      }, 1000);
    },
    getCaptcha(type = 'captchatoken') {
      if (this.isGetValidateCode) return
      this[type] = (Math.random() * 10).toString().slice(-6);
    },
    back() {
      if (this.loginType === 3) {
        this.loginType = 1
        return
      }
      // 返回上一级
      if (!this.step(3)) {
        this.captchatoken = ''
      }
      this.setStep(this.loginStep - 1)
    },
    // 去掉账号前后多余空格
    trim(str) {
      str = str.replace(/^(\s|\u00A0)+/, '');
      for (var i = str.length - 1; i >= 0; i--) {
        if (/\S/.test(str.charAt(i))) {
          str = str.substring(0, i + 1);
          break;
        }
      }
      return str;
    },
    async toAccountLogin(date) {
      const Num = date.accesstoken
      const res = await login(date)
      if (res.code === 0) {
        this.$store.state.postUrl = [];
        if (Object.prototype.hasOwnProperty.call(res.data, 'listschool')) {
          res.data.schoolMsg = res.data.listschool[0];
          localStorage.setItem("userMsg", JSON.stringify(res.data));
          const flag = await this.loginToken(res.data.listschool[0].schoolId, res.data.userId, Num)
          return flag
        } else {
          res.data[0].schoolMsg = res.data[0].listschool[0]
          localStorage.setItem("userMsg", JSON.stringify(res.data[0]));
          const flag = await this.loginToken(res.data[0].listschool[0].schoolId, res.data[0].userId, Num)
          return Boolean(flag)
        }
      } else {
        this.$message.error(res.msg);
        this.isLoading = false
        if (res.data && res.data.num && res.data.num >= this.captchaNum) {
          this.validateInfo.isSuccess = false
          this.getCaptcha();
        }
        return true
      }
    },
    toSmsvalidLogin(res) {
      this.$store.state.postUrl = [];
      res.schoolMsg = res.listschool[0];
      localStorage.setItem("userMsg", JSON.stringify(res));
      const schoolId = res.listschool[0].schoolId
      const userId = res.userId
      this.loginToken(schoolId, userId, this.verificationCode);
    },
    async goLogin() {
      const { imagecaptchatoken, moveLength } = this.validateInfo
      this.isLoading = true
      try {
        if (this.step(1)) {
          // 通过账号登录
          let Num = ''
          for (let i = 0; i < 6; i++) {
            Num += Math.floor(Math.random() * 10);
          }
          const date = {
            username: this.trim(this.account),
            password: this.password,
            accesstoken: Num,
            accounttype: this.activeTab,
            smtype: 1 //密码国密加密
          }
          if (!this.account) {
            this.isLoading = false
            this.$message.error('账号不能为空');
            return
          } else if (!this.password) {
            this.isLoading = false
            this.$message.error('密码不能为空');
            return
          }
          if (this.captchatoken) {
            if (!this.onvalidateInfo()) return
            date.moveLength = moveLength
            date.imagecaptchatoken = imagecaptchatoken
          }
          // 使用新的加密方法替换原有的 sha1
          date.password = encryptPassword(date.password)
          // date.password = sha1(date.password)
          if (date.accounttype === 3) {
            date.skey = this.skey
            date.accesstoken = Num
            const res = await getphonemultipleaccounts(date)
            if (res.code === 0) {
              if (res.data.length === 0) {
                this.$message.error('用户不存在')
              } else if (res.data.length === 1) {
                const list = res.data[0]
                this.$store.state.postUrl = [];
                list.schoolMsg = list.listschool[0];
                localStorage.setItem("userMsg", JSON.stringify(list));
                this.loginToken(list.listschool[0].schoolId, list.userId, Num);
              } else if (res.data.length > 1) {
                this.userList = res.data
                this.isViewChangeUser = true
                this.isLoading = false
              }
              return
            } else {
              this.$message.error(res.msg);
              this.isLoading = false
              if (res.data && res.data.num && res.data.num >= this.captchaNum) {
                this.validateInfo.isSuccess = false
                this.getCaptcha();
              }
              return
            }
          } else {
            const flag = await this.toAccountLogin(date)
            if (flag) return
          }
        } else if (this.step(2)) {
          // 短信验证码登录
          if (!this.onvalidateAccount()) return
          if (!this.onvalidateInfo()) return
          let date = {
            imagecaptchatoken,
            moveLength,
            phone: this.account,
            validcode: this.verificationCode,
            skey: this.skey
          }
          const res = await smsvalidcodemultipleaccountslogin(date)
          if (res.code === 0) {
            if (res.data.length > 1) {
              this.userList = res.data
              this.isViewChangeUser = true
              this.isLoading = false
              return
            } else if (res.data.length === 0) {
              this.$message.error('用户不存在')
              return
            } else {
              this.toSmsvalidLogin(res.data[0])
            }
          } else {
            this.isLoading = false
            this.$message.error(res.msg);
            return
          }
        } else if (this.step(3)) {
          // 找回密码
          if (!this.onvalidateAccount()) return
          if (!this.onvalidateVeri()) return
          if (!this.onvalidateInfo()) return
          const obj = {
            phone: this.account,
            validcode: this.verificationCode,
            imagecaptchatoken,
            moveLength
          }
          const res = await openapiValidsliderpasswordcode(obj)
          this.isLoading = false
          if (res.code === 0) {
            this.setp3UserName = res.data || []
            this.getuserschoollist(this.setp3UserName[0])
            this.setStep(4)
          } else {
            this.$message.error(res.msg)
            this.validateInfo.isSuccess = false
          }
          return
        } else if (this.step(4)) {
          if (this.password.length < 8) {
            this.isLoading = false
            this.$message.error('密码长度少于8位')
            return false;
          }
          if (JSON.stringify(this.pwdconfig) !== '{}') {
            // 密码强度验证
            let regx = null
            switch (this.pwdconfig.pwdlevel.level) {
              case 1:
                regx = new RegExp("^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[~!@#$%^&*])[\\da-zA-Z~!@#$%^&*]{8,20}$")
                if (!regx.test(this.password)) {
                  this.isLoading = false
                  this.$message.error('密码必须包含英文（含大小写）+ 数字 + 特殊字符')
                  return false
                }
                break;
              case 2:
                regx = new RegExp("^(?=.*\\d)(?=.*[a-zA-Z])(?=.*[~!@#$%^&*])[\\da-zA-Z~!@#$%^&*]{8,20}$")
                if (!regx.test(this.password)) {
                  this.isLoading = false
                  this.$message.error('密码必须包含英文+ 数字 + 特殊字符')
                  return false
                }
                break;
              case 3:
                regx = /^(?=.*[a-zA-Z])(?=.*\d).{8,20}$/
                if (!regx.test(this.password)) {
                  this.isLoading = false
                  this.$message.error('密码必须包含英文+ 数字')
                  return false
                }
                break;
              default:
                break;
            }
          } else {
            let regx = /^(?=.*[a-zA-Z])(?=.*\d).{8,20}$/
            if (!regx.test(this.password)) {
              this.isLoading = false
              this.$message.error('密码必须包含英文+ 数字')
              return false
            }
          }
          if (this.password !== this.cpassword) {
            this.isLoading = false
            this.$message.error('两次输入的密码不一致')
            return
          }

          const date = {
            phone: this.account,
            username: this.trim(this.setp3UserName[0]),
            validcode: this.verificationCode,
            imagecaptchatoken,
            moveLength,
            password: this.password,
            schoolId: this.schoolId
          }
          date.password = sha1(date.password)
          const res = await openapiResetpassword(date)
          if (res.code === 0) {
            this.$message.success('修改密码成功~')
            this.resetData()
            this.setStep(1)
          } else {
            this.$message.error(res.msg)
            this.isLoading = false
            return
          }
        }
      } catch (error) {
        this.$message.error('流程错误')
        console.log(error, 'error')
        this.isLoading = false
        return
      }
      this.isLoading = false
      this.visible = false
    },
    onvalidateVeri() {
      if (!this.verificationCode) {
        this.isLoading = false
        this.$message.error('请输入验证码')
        return false
      }
      return true
    },
    onvalidateAccount() {
      if (!iphone(this.account)) {
        this.isLoading = false
        this.$message.error('请输入正确的电话号码')
        return false
      } else {
        return true
      }
    },
    onvalidateInfo() {
      if (!this.validateInfo.isSuccess) {
        this.isLoading = false
        this.$message.error("请完成拼图验证");
        return false
      } else {
        return true
      }
    },
    //- 获取登录验证码弹出条件
    getsecurityrules() {
      let that = this;
      getsecurityrules().then(res => {
        console.log("res==", res);
        if (res.code === 0) {
          this.captchaNum = res.data.num
          if (res.data.top || res.data.num == 0) {
            this.getCaptcha();
          }
        } else {
          that.$message.error(res.msg);
        }
      })
        .catch(error => {
          console.log(error);
        });
    },
    //- 重置密码-获取登录验证码弹出条件
    getuserschoollist(val) {
      let that = this;
      const obj = {
        username: val
      }
      getuserschoollist(obj).then(res => {
        if (res.code === 0 && res.data[0].pwdconfig) {
          that.pwdconfig = JSON.parse(res.data[0].pwdconfig)
          that.pwdLevel = that.pwdconfig.pwdlevel.level - 1
          that.schoolId = res.data[0].schoolId
        } else {
          that.$message.error(res.msg);
        }
      })
        .catch(error => {
          console.log(error);
        });
    },
    //- 外网注册获取安全策略配置
    getoutpwdconfig() {
      let that = this;
      const obj = {
        skey: that.skey
      }
      getoutpwdconfig(obj).then(res => {
        if (res.code === 0 && res.data) {
          that.pwdconfig = JSON.parse(res.data)
          that.pwdLevel = that.pwdconfig.pwdlevel.level - 1
        }
      })
        .catch(error => {
          console.log(error);
        });
      // 晋江一中不调用获取配置密码接口
      if (this.$apiurl !== 'https://zhxy.jjyz.net') {
        getoutregistercode(obj).then(res => {
          if (res.code === 0 && res.data) {
            this.pwdKey = res.data.keynumber
          } else {
            console.log("getoutregistercode==", res.msg);
          }
        })
          .catch(error => {
            console.log(error);
          });
      }
    },
    //- 获取token
    async loginToken(schoolId, openId, accesstoken) {
      let date = {
        schoolId: schoolId,
        openId: openId,
        accesstoken: accesstoken
      };
      this.isLoading = false
      const res = await getaccesstoken(date).catch(error => { console.log(error) });
      if (res.code === 0) {
        if (this.wxopenId) {
          this.sendLoginmpmessage();
          if (this.wxLoginStatus === 'visitor') {
            console.log("微信扫码注册登录后的token===", res.data.accesstoken);
            this.$emit('getToken', res.data.accesstoken)
            return;
          }
        }
        if (Number(res.data.login) === 0 || res.data.login === "" || res.data.resetpwd) {
          localStorage.setItem("user", JSON.stringify({ apiurl: res.data.apiurl }));
          let val = {
            title: "重置密码",
            bottom: "确定",
            origin: "renewPaw",
            name: res.data.name,
            res: res
          }
          this.$refs.upIphone.showDialog(val);
          return true
        }
        localStorage.setItem("user", JSON.stringify(res.data));
        document.cookie = "accesstoken=" + res.data.accesstoken + ";path=/";
        emitter.emit('changeLoginStatus')
        this.visible = false
        if (!this.wxChooseInfo) {
          this.getUserDesks()
        }
      } else {
        this.$message.error(res.msg);
      }
    },
    findPass() {
      this.getCaptcha()
      this.setStep(3)
    },
    resetData() {
      this.imgCode = ''
      this.verificationCode = ''
      this.account = ''
      this.password = ''
      this.cpassword = ''
      this.captchatoken = ''
      this.webSocketInfo = {}
      this.registerInfo = {}
    },
    goRegister() {
      webSocketClass.constructor("wss://user.topeti.com/webmessage", this.webSocketContent.bind(this));
      webSocketClass.connect();
    },
    webSocketContent(e) {
      if (e.action === 'connected') {
        this.webSocketToken = e.msg.token
      } else if (e.action === 'register') {
        const data = e.msg.info
        let Num = ''
        for (let i = 0; i < 6; i++) {
          Num += Math.floor(Math.random() * 10);
        }
        data.accesstoken = Num
        this.webSocketInfo = data
        this.visible = false
        this.visibleReg = true
      }
    },
    // 微信注册扫码成功返回
    wxloginSuccess(res) {
      // 未注册用户
      if (res.code === 101) {
        // 打开了公众号登录并且该用户未注册
        if (this.openGzhLogin && !this.openregister) {
          this.$message.error("用户未注册,请先注册")
          return false;
        }
        let regStatus = true;
        this.wxopenId = res.data
        console.log("未注册用户", this.fOptions);
        // 如果配置存在必填项，则用户手动填写后注册
        for (const item of this.fOptions) {
          if (item.required) {
            this.setType(2, 'registerType')
            regStatus = false;
            break; // 退出循环
          }
        }
        if (regStatus) {
          this.resRegister()
          // 如果配置存在选项，则用户选填的同时进行注册
          for (const item of this.fOptions) {
            if (item.isAppen) {
              this.wxChooseInfo = true;
              break; // 退出循环
            }
          }
        }
      }
      // 已注册用户
      else {
        const _token = res.data.accesstoken.accesstoken
        this.wxopenId = res.data.userinfo.wxopenId
        this.isLoading = false
        this.visible = false
        this.sendLoginmpmessage(_token);
        console.log("已注册用户");
        // 临时登录
        if (this.wxLoginStatus === 'visitor') {
          this.$emit('getToken', res.data.accesstoken.accesstoken)
          console.log("微信扫码注册登录后的token===", _token);
          return;
        }
        else {
          res.data.userinfo.schoolMsg = res.data.userinfo.listschool[0];
          localStorage.setItem("userMsg", JSON.stringify(res.data.userinfo));
          localStorage.setItem("user", JSON.stringify(res.data.accesstoken));
          document.cookie = "accesstoken=" + res.data.accesstoken.accesstoken + ";path=/";
          emitter.emit('changeLoginStatus')
          this.getUserDesks()
        }
      }
    },
    // 获取用户所属的所有角色
    getUserDesks() {
      getuserdesks().then((res) => {
        console.log("reaaaas==", res);
        if (res && res.code === 0) {
          // 存在角色门户并且已开启的情况下跳转到首页
          if (res.data.openrole === true && res.data.list.length > 0) {
            window.open('/index', '_blank')
          }
          else {
            console.log("停留在当前页面,不跳转首页");
            this.visibleReg = false
          }
        }
      });
    },
    // 微信安全注册-登录成功返回消息推送
    sendLoginmpmessage(token) {
      sendloginmpmessage({
        skey: this.skey,
        wxopenId: this.wxopenId,
        accesstoken: token
      }).then(res => {
        console.log("ressendLoginmpmessage==", res);
      })
    },
    // 关闭弹窗
    closeDialog() {
      this.visible = false
      if (this.$refs.regWxRef) {
        this.$refs.regWxRef.clearPoll()
      }
    }
  },
  computed: {
    isXiamenUniversity() {
        const li = [
            'smart-aerospace.xmu.edu.cn',
            'smart-aerospace2.xmu.edu.cn',
            'idata.xmu.edu.cn',
            'smartsbd.xmu.edu.cn',
            'smartsbd2.xmu.edu.cn',
            'chemplatform.xmu.edu.cn'
        ]
        return li.includes(window.location.host)
    },
    upType() {
      return this.loginInfo.qrCode === 'illustration' ? 'qrImg' : 'img'
    },
    isAppenQrCode() {
      return this.loginInfo.qrCode === 'right' || this.type(2, 'registerType') || this.type(3, 'registerType')
    },
    tabOptionList() {
      if (this.loginInfo.loginMethods === undefined) {
        return this.tabOption
      } else {
        const list = this.loginInfo.loginMethods.filter(c => c.isAppen)
        return list
      }
    },
    isNew() {
      let flag = true
      const img = this.loginInfo[this.upType]
      if (Array.isArray(img) && img.length !== 0) {
        flag = false
      }
      return flag
    },
    numLimit() {
      return {
        username: true,
        password0: true,
        password: true,
        undefined: false
      }
    },
    activePlaceholder() {
      if (this.step(1)) {
        const act = this.tabOption.find(item => item.value === this.activeTab)
        return act.placeholder
      } else if (this.step(2) || this.step(3)) {
        return '请输入手机号'
      } else {
        return ''
      }
    },
    webUrl() {
      return `${this.$hfurl}/page/hfReg/hfReg?skey=${this.skey}&webSocketToken=${this.webSocketToken}`
    },
    loginTitle() {
      let title = ''
      if (this.step(1) && this.type(1, 'registerType')) {
        title = '登录'
      } else if (this.step(2) && this.type(1, 'registerType')) {
        title = '手机动态码登录'
      } else if (this.step(3) && this.type(1, 'registerType')) {
        title = '忘记密码'
      } else if (this.step(4) && this.type(1, 'registerType')) {
        title = '重置密码'
      } else if (this.type(2, 'registerType') && this.step(1, 'registerStep')) {
        title = '注册'
      } else if (this.type(2, 'registerType') && this.step(2, 'registerStep')) {
        title = '请完善一下信息'
      }
      return title
    },
    qrTitle() {
      let title = ''
      if (this.type(3, 'registerType')) {
        title = '微信安全注册'
      } else {
        title = '微信安全登录'
      }
      return title
    },
    loginBtnText() {
      let str = ''
      if (this.step(4)) {
        str = '确认'
      } else if (this.step(3)) {
        str = '重置密码'
      } else {
        str = '登录'
      }
      return str
    },
    isRegister() {
      return this.openregister === 1
    },
    isLogin() {
      return this.openLogin === 1
    },
    imgUrl() {
      if (this.loginInfo[this.upType] && this.loginInfo[this.upType].length !== 0) {
        return this.$imgurl + this.loginInfo[this.upType]
      } else {
        const obj = {
          img: 'loginInfo',
          qrImg: 'qrCode'
        }
        return `http://bigdata.topeti.com/PCRepository/image/${obj[this.upType]}.png`
      }
    },
    fShow() {
      return {
        '用户名': true,
        '姓名': true,
        '密码': true,
        '手机号': true,
        '确认密码': true
      }
    },
    fOptions() {
      if (this.registerconfig.setOptions) {
        return this.registerconfig.setOptions.filter(item => this.fShow[item.name])
      } else {
        return []
      }
    },
    sOptions() {
      if (this.registerconfig.setOptions) {
        return this.registerconfig.setOptions.filter(item => !this.fShow[item.name] && item.isAppen)
      } else {
        return []
      }
    },
    isNext() {
      return this.sOptions.length !== 0
    },
    isPd() {
      return (this.fOptions.length >= 2 && this.isNeedPhoneValidate && this.step(1, 'registerStep')) || (this.sOptions.length >= 3 && this.step(2, 'registerStep'))
    },
    showIcon() {
      if (this.type(1, 'registerType')) {
        return this.loginInfo.qrCode === 'right' || this.type(2, 'registerType') || this.type(3, 'registerType')
      } else {
        return this.isAccountRegister && this.isWXRegister
      }
    }
  },
}
</script>

<style scoped lang="scss">
$themeColor: var(--themeColor);

.xmulogin {
  text-align: center;
  .xmu {
      cursor: pointer;
      width: 180px;
  }
}

.validate-title {
  height: 46px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  color: #666;
  border-bottom: solid 1px #d8d8d8;

  span {
    font-size: 14px;
  }

  i {
    cursor: pointer;

    &:hover {
      color: $themeColor;
    }
  }
}
.validate-box {
  padding-bottom: 65px;
  display: flex;
  justify-content: center;
  margin: 20px 0;
}

.login-info {
  min-height: 564px;
  display: flex;
  position: relative;

  .close-dia {
    position: absolute;
    right: -40px;
    top: -40px;
    cursor: pointer;

    .icon-guanbi2fill {
      font-size: 32px;
      color: #ffffff7f;
    }
  }

  &-img {
    width: 388px;
    min-height: 100%;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }

    .el-carousel {
      height: 100%;

      .el-carousel__container {
        height: 100%;
      }

      .el-carousel__indicators {
        .el-carousel__button {
          width: 7px;
          height: 7px;
          border-radius: 100%;
        }
      }
    }
  }

  &-con {
    flex: 1;

    li {
      list-style: none;
    }

    .l-login {
      box-sizing: border-box;
      padding-left: 67px;
      padding-top: 65px;
      width: 100%;
      height: 100%;

      &-text {
        margin-bottom: 8px;
      }

      &-tips {
        margin-bottom: 32px;

        span {
          color: $themeColor;
          cursor: pointer;

          &:hover {
            text-decoration: underline;
          }
        }
      }

      &-tab {
        display: flex;
        margin-bottom: 32px;

        .logon-tab {
          font-family: PingFangSC;
          color: #333333;
          font-weight: 400;
          font-size: 16px;
          line-height: 22px;
          margin-right: 40px;
          position: relative;
          cursor: pointer;

          &::after {
            position: absolute;
            content: '';
            left: 0;
            width: 100%;
            height: 1px;
            background-color: $themeColor;
            bottom: -3px;
            display: none;
          }

          &:last-of-type {
            margin-right: 0;
          }
        }

        .active-tab {
          &::after {
            display: inline-block;
          }
        }
      }

      &-inp {
        margin-bottom: 24px;

        .el-input {
          width: 394px;
        }

        .inp-imgcode {
          .el-input__suffix {
            right: 15px;

            .el-input__suffix-inner {
              line-height: 48px;
              color: $themeColor;

              .inp-img {
                width: 75px;
                height: 100%;
                display: flex;
                align-items: center;

                img {
                  height: 30px;
                  width: 100%;
                }
              }
            }
          }
        }
      }

      &-phone {
        display: flex;

        .el-input {
          width: 256px;
          margin-right: 16px;
        }

        .inp-validate {
          border-radius: 8px;
          background-color: $themeColor;
          width: 115px;
          height: 48px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          cursor: pointer;
        }
      }

      &-validate {
        width: 394px;
        height: 48px;
        border-radius: 28px;
        border: 1px solid #D7D7D7;
        text-align: center;
        line-height: 48px;
        margin-bottom: 24px;
        cursor: pointer;
        user-select: none;
      }

      .validate-scuuess {
        border-color: #43BF97;
        color: #43BF97;

        svg {
          vertical-align: middle;
          position: relative;
          margin-right: 5px;
        }
      }

      &-tool {
        display: flex;
        justify-content: space-between;
        padding-right: 67px;
        box-sizing: border-box;
        margin-bottom: 32px;

        div {
          font-family: PingFangSC;
          font-weight: 400;
          font-size: 14px;
          color: #999999;
          cursor: pointer;
          line-height: 20px;
        }

        .dynamic {
          color: $themeColor;
        }
      }

      &-btn {
        padding-right: 67px;
        box-sizing: border-box;
        height: 48px;
        display: flex;

        .btn {
          background-color: $themeColor;
          color: #fff;
          width: 100%;
          height: 100%;
        }

        .cancle {
          background-color: #F7F8FA;
          border: 1px solid #F3F3F3;
          color: $themeColor;
        }
      }
    }

    .login-tipsss {
      span {
        color: $themeColor;
        cursor: pointer;

        &:hover {
          text-decoration: underline;
        }
      }
    }

    .qr-login {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 97px;
      box-sizing: border-box;

      &-img {
        width: 255px;
        height: 255px;
        margin-bottom: 8px;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .to-other {
    width: 56px;
    height: 56px;
    position: absolute;
    background-color: #fff;
    right: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
    box-sizing: border-box;

    &-tips {
      position: absolute;
      right: 40px;
      top: 29px;
      height: 23px;
      box-shadow: 0px 12px 30px 0px rgba(145, 145, 145, 0.25);
      width: fit-content;
      white-space: nowrap;
      color: $themeColor;
      padding: 3px 7px;
      line-height: 23px;
      background-color: #fff;
      z-index: 2;

      &::after {
        position: absolute;
        content: '';
        position: absolute;
        display: block;
        width: 0;
        height: 0;
        right: -6px;
        top: calc(50% - 6px);
        border-bottom: 6px solid transparent;
        border-left: 6px solid #fff;
        border-top: 6px solid transparent;
      }
    }

    .iconfont {
      font-size: 40px;
      color: $themeColor;
      cursor: pointer;
      z-index: 2;
      position: relative;
      -webkit-clip-path: polygon(100% 0, 0 0, 100% 100%);
      clip-path: polygon(100% 0, 0 0, 100% 100%);
    }

    .icon-erweima- {
      font-size: 48px !important;
    }
  }

  .back-prev {
    position: absolute;
    left: 416px;
    top: 25px;

    i {
      display: block;
      transform: rotate(180deg);
      color: #CDCDCD;
      font-size: 18px;
      cursor: pointer;

      &:hover {
        color: $themeColor;
      }
    }
  }
}
::v-deep .login-inp {
  .el-input__wrapper {
    background-color: #F7F8FA;
    .el-input__inner {
      border: none;
      height: 48px;
      line-height: 48px;
    }
  }
}

::v-deep .register-sel {
  .el-input__wrapper {
    background-color: #F7F8FA;
    .el-input__inner {
      height: 48px;
      line-height: 48px;
    }
  }

  .el-icon-date {
    line-height: 48px;
  }
}

.login-btn {
  border-radius: 8px;
  outline: none;
  border: none;
  cursor: pointer;
  font-weight: 500;
  font-size: 16px;

  &:active {
    transform: scale(.99);
    border: none;
    outline: none;
  }
}

.login-title {
  font-family: PingFangSC;
  color: #333333;
  font-weight: 600;
  line-height: 45px;
  font-size: 24px;
  user-select: none;
}

.login-tips {
  font-family: PingFangSC;
  color: #666666;
  font-weight: 400;
  font-size: 14px;
}

.tip-words {
  width: 394px;
  padding-top: 50px;
  text-align: center;
  white-space: nowrap;
  color: #666;

  p {
    line-height: 1.5;
  }
}

::v-deep .sign-up-success {
  .sign-up {
    height: 564px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    justify-content: center;
    align-items: center;
    padding: 70px 100px;

    &-img {
      width: 200px;
      height: 200px;
    }

    &-title {
      font-family: PingFangSC;
      color: #333333;
      font-weight: 600;
      font-size: 32px;
      font-style: normal;
      text-decoration: none;
      text-align: center;
    }

    &-btn {
      width: 206px;
      height: 48px;
      background-color: #4f86ff;
      color: #fff;
    }
  }
}

::v-deep .wx-login-qr {
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 2;
  transform: translate(-50%, -50%);

  iframe {
    width: 200px !important;
    height: 200px;
    border: none;
    background-color: #fff;
    box-sizing: border-box;
  }
}
</style>
